var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_vm.form.id ? _c('v-card-title', [_vm._v("Edit destination")]) : _vm._e(), !_vm.form.id && !_vm.hideHeader ? _c('v-card-title', [_vm._v("Add destination")]) : _vm._e(), _c('v-card-text', {
    staticClass: "destination-logic pa-0"
  }, [_c('div', {
    staticClass: "pa-5"
  }, [_c('v-form', {
    ref: "destination-form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('div', {
    staticClass: "destination-name-ctn my-3"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(" Scan destination name: ")]), _c('v-text-field', {
    attrs: {
      "rules": _vm.rules.name,
      "maxlength": "50",
      "counter": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('div', {
    staticClass: "destination"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(" Choose a scan destination: ")]), _c('div', {
    staticClass: "d-flex align-start py-3"
  }, [_c('v-select', {
    staticClass: "flex-grow-0 py-0 mr-2",
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "label": "Destination type",
      "items": _vm.destinations,
      "item-text": "value",
      "item-value": "key",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }), _c('div', [_vm.form.type === 'url' ? _c('v-text-field', {
    attrs: {
      "rules": _vm.rules.url,
      "validate-on-blur": "",
      "label": "URL",
      "outlined": "",
      "dense": ""
    },
    on: {
      "focus": _vm.onFocusUrl,
      "blur": _vm.onBlurUrl
    },
    model: {
      value: _vm.form.url,
      callback: function ($$v) {
        _vm.$set(_vm.form, "url", $$v);
      },
      expression: "form.url"
    }
  }) : _vm._e(), _vm.form.type === 'stc' || _vm.isAvailable('editor:authentication') && _vm.form.type === 'url' ? _c('div', [_vm.form.type === 'url' ? _c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" Select an authentication app branding experience to link to this redirection URL. Remember to update the URL to include the required search parameters - eg. https://custom.url/?uid={id}&api_key={api_key} ")]) : _vm._e(), _c('v-autocomplete', {
    ref: "landingPageAutoComplete",
    attrs: {
      "items": _vm.filteredLandingPages,
      "loading": _vm.landingPagesLoading,
      "placeholder": _vm.form.type === 'url' ? 'None' : 'Landing page',
      "search-input": _vm.landingPageSearchText,
      "item-text": "name",
      "item-value": "id",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "no-filter": true,
      "no-data-text": _vm.landingPagesLoading ? 'Loading...' : 'No data found.',
      "rules": _vm.stcConfigRules
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.landingPageSearchText = $event;
      },
      "update:search-input": function ($event) {
        _vm.landingPageSearchText = $event;
      }
    },
    scopedSlots: _vm._u([_vm.form.type === 'url' ? {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          on: {
            "click": _vm.selectNone
          }
        }, [_c('v-list-item-title', [_vm._v("None")])], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.form.stc_config,
      callback: function ($$v) {
        _vm.$set(_vm.form, "stc_config", $$v);
      },
      expression: "form.stc_config"
    }
  }), _c('div', {
    staticClass: "section-hint"
  }, [_c('span', {
    staticClass: "my-2"
  }, [_c('v-icon', [_vm._v("mdi-information-outline")]), _vm._v(" To update the landing page content, go to: "), _c('v-btn', {
    staticClass: "my-2",
    attrs: {
      "color": "primary",
      "small": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.goToLandingPages();
      }
    }
  }, [_vm._v("Landing pages")])], 1)])], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    staticClass: "conditions mt-3"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(" Conditions: ")]), _vm.form.conditions && (_vm.form.conditions.or && _vm.form.conditions.or.length || _vm.form.conditions.and && _vm.form.conditions.and.length) ? _c('div', {
    staticClass: "section-hint"
  }, [!_vm.deleteMode ? _c('div', {
    staticClass: "py-2"
  }, [_c('v-icon', [_vm._v("mdi-information-outline")]), _vm._v(" To delete conditions: "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": function ($event) {
        _vm.deleteMode = !_vm.deleteMode;
      }
    }
  }, [_vm._v(" click here ")])], 1) : _vm._e(), _vm.deleteMode ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function ($event) {
        _vm.deleteMode = !_vm.deleteMode;
      }
    }
  }, [_vm._v(" Done deleting ")]) : _vm._e()], 1) : _vm._e(), !_vm.form.conditions || _vm.form.conditions && _vm.form.conditions['=='] ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v(" No conditions set yet. All scans will be redirected to the selected destination. Start creating conditions for specific scans. ")]), _c('div', {
    staticClass: "d-flex my-2 justify-center align-center"
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.addFirstConditionBlock();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-plus-circle-outline")]), _vm._v(" Create conditions ")], 1)], 1)]) : _c('div', [_vm._l(_vm.form.conditions, function (mainConditions, mainOperator) {
    return _c('div', {
      key: `main-${mainOperator}`
    }, _vm._l(_vm.form.conditions[mainOperator], function (blocks, index) {
      return _c('div', {
        key: `block-${index}`
      }, [_vm._l(blocks, function (conditions, operator) {
        return _c('div', {
          key: `block-${index}-conditions-${operator}`
        }, [operator === 'or' || operator === 'and' ? _c('div', {
          staticClass: "nested-conditions mt-4"
        }, [!_vm.deleteMode && conditions.length > 1 ? _c('div', {
          staticClass: "condition-header d-flex justify-center"
        }, [_c('div', {
          staticClass: "condition-header-ctn py-4 px-5 d-flex align-center"
        }, [_vm._v(" Expressions inside are connect by "), _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c('button', _vm._g(_vm._b({
                staticClass: "d-flex ml-2 align-center justify-center font-mono conditional-operator"
              }, 'button', attrs, false), on), [_vm._v(" " + _vm._s(operator) + " "), _c('v-icon', {
                attrs: {
                  "color": "primary"
                }
              }, [_vm._v(" mdi-menu-down ")])], 1)];
            }
          }], null, true)
        }, [_c('v-list', _vm._l(_vm.conditionalOperators, function (item) {
          return _c('v-list-item', {
            key: item.key,
            on: {
              "click": function ($event) {
                return _vm.selectOperator(item.key, `${mainOperator}.${index}.${operator}`);
              }
            }
          }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.value) + " ")])], 1);
        }), 1)], 1)], 1)]) : _vm._e(), _vm._l(conditions, function (nestedBlocks, nestedBlocksIndex) {
          return _c('div', {
            key: `block-${index}-conditions-${operator}-nested-blocks-${nestedBlocksIndex}`
          }, _vm._l(nestedBlocks, function (nestedConditions, nestedOperator) {
            return _c('div', {
              key: `block-${index}-conditions-${operator}-nested-blocks-${nestedBlocksIndex}-nested-op-${nestedOperator}`
            }, [_c('div', {
              staticClass: "d-inline-flex my-2 align-center"
            }, [_c('v-btn', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: _vm.deleteMode,
                expression: "deleteMode"
              }],
              attrs: {
                "color": "red",
                "icon": ""
              },
              on: {
                "click": function ($event) {
                  return _vm.deleteNestedConditionBlock(conditions, nestedBlocksIndex, _vm.form.conditions[mainOperator], index);
                }
              }
            }, [_c('v-icon', [_vm._v("mdi-minus-circle-outline")])], 1), _vm.getTypeof(nestedConditions[0].var) === 'object' || _vm.getTypeof(nestedConditions[0].var) === 'string' && nestedConditions[0].var.indexOf('scm') === -1 ? _c('v-autocomplete', {
              staticClass: "parameter-select mx-1",
              attrs: {
                "items": _vm.variables,
                "item-text": "description",
                "item-value": "value",
                "dense": "",
                "hide-details": "",
                "outlined": "",
                "placeholder": "Select a parameter"
              },
              on: {
                "change": function ($event) {
                  return _vm.onVariableChange(nestedConditions, nestedOperator);
                }
              },
              model: {
                value: nestedConditions[0].var,
                callback: function ($$v) {
                  _vm.$set(nestedConditions[0], "var", $$v);
                },
                expression: "nestedConditions[0].var"
              }
            }) : _vm._e(), nestedConditions[0].var !== null && _vm.getTypeof(nestedConditions[0].var) === 'string' && nestedConditions[0].var.indexOf('scm') > -1 ? _c('div', {
              staticClass: "d-flex align-center outlined"
            }, [_vm._v(" SCM Field "), _c('v-btn', {
              staticClass: "ml-2",
              attrs: {
                "icon": ""
              },
              on: {
                "click": function ($event) {
                  nestedConditions[0].var = '';
                }
              }
            }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e(), _vm.getTypeof(nestedConditions[0].var) === 'string' && nestedConditions[0].var.indexOf('scm') >= 0 ? _c('v-combobox', {
              staticClass: "parameter-select mx-1",
              class: {
                'no-arrow': _vm.rulesScmFields.length === 0
              },
              attrs: {
                "value": nestedConditions[0].var === 'scm' ? '' : nestedConditions[0].var,
                "label": "SCM field",
                "outlined": "",
                "hide-details": "",
                "dense": "",
                "item-text": "description",
                "item-value": "key",
                "return-object": false,
                "items": _vm.rulesScmFields
              },
              on: {
                "change": function ($event) {
                  return _vm.onScmChange($event, nestedConditions[0]);
                }
              },
              scopedSlots: _vm._u([{
                key: "selection",
                fn: function (data) {
                  return [_vm._v(" " + _vm._s(_vm.rulesScmFields.find(function (scm) {
                    return scm.key === data.item;
                  }) ? _vm.rulesScmFields.find(function (scm) {
                    return scm.key === data.item;
                  }).description : data.item.split('scm_')[1]) + " ")];
                }
              }], null, true),
              model: {
                value: nestedConditions[0].var,
                callback: function ($$v) {
                  _vm.$set(nestedConditions[0], "var", $$v);
                },
                expression: "nestedConditions[0].var"
              }
            }) : _vm._e(), _c('v-menu', {
              attrs: {
                "offset-y": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function (_ref2) {
                  var on = _ref2.on,
                    attrs = _ref2.attrs;
                  return [_c('v-btn', _vm._g(_vm._b({
                    staticClass: "operator-btn mx-1",
                    attrs: {
                      "outlined": ""
                    }
                  }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.getOperator(nestedOperator).value) + " "), _c('v-icon', {
                    attrs: {
                      "color": "primary"
                    }
                  }, [_vm._v(" mdi-menu-down ")])], 1)];
                }
              }], null, true)
            }, [_c('v-list', _vm._l(_vm.operators, function (item) {
              return _c('v-list-item', {
                key: item.key,
                on: {
                  "click": function ($event) {
                    return _vm.selectOperator(item.key, `${mainOperator}.${index}.${operator}.${nestedBlocksIndex}.${nestedOperator}`);
                  }
                }
              }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.value) + " ")])], 1);
            }), 1)], 1), _c('div', {
              staticClass: "value-input mx-1"
            }, [_c('logic-value-input', {
              attrs: {
                "operator": nestedOperator,
                "type": nestedConditions[0].var,
                "value": nestedConditions[1]
              },
              on: {
                "update:value": function ($event) {
                  return _vm.$set(nestedConditions, 1, $event);
                }
              }
            })], 1), nestedBlocksIndex < conditions.length - 1 ? _c('div', {
              staticClass: "flex-grow-1 mx-1 font-mono"
            }, [_vm._v(" " + _vm._s(operator) + " ")]) : _c('v-btn', {
              attrs: {
                "icon": "",
                "color": "primary"
              },
              on: {
                "click": function ($event) {
                  return _vm.addNestedConditionBlock(`${mainOperator}.${index}.${operator}`);
                }
              }
            }, [_c('v-icon', [_vm._v("mdi-plus-circle-outline")])], 1)], 1)]);
          }), 0);
        })], 2) : _c('div', [_c('div', {
          staticClass: "d-inline-flex"
        }, [_c('v-select', {
          attrs: {
            "items": _vm.variables,
            "dense": "",
            "hide-details": "",
            "item-text": "description",
            "item-value": "value",
            "outlined": ""
          },
          on: {
            "change": function ($event) {
              return _vm.onVariableChange(conditions, operator);
            }
          },
          model: {
            value: conditions[0].var,
            callback: function ($$v) {
              _vm.$set(conditions[0], "var", $$v);
            },
            expression: "conditions[0].var"
          }
        }), _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref3) {
              var on = _ref3.on,
                attrs = _ref3.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "primary",
                  "dark": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(operator) + " ")])];
            }
          }], null, true)
        }, [_c('v-list', _vm._l(_vm.operators, function (item) {
          return _c('v-list-item', {
            key: item.key,
            staticClass: "pointer",
            on: {
              "click": function ($event) {
                return _vm.selectOperator(item.key, `${mainOperator}.${index}.${operator}`);
              }
            }
          }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.value) + " ")])], 1);
        }), 1)], 1), _c('div', {
          staticClass: "value-input"
        }, [_c('logic-value-input', {
          attrs: {
            "operator": operator,
            "type": conditions[0].var,
            "value": conditions[1]
          },
          on: {
            "update:value": function ($event) {
              return _vm.$set(conditions, 1, $event);
            }
          }
        })], 1)], 1)])]);
      }), index != _vm.form.conditions[mainOperator].length - 1 ? _c('div', {
        staticClass: "expression-connector"
      }, [_c('div', {
        staticClass: "connector"
      }), _c('div', {
        staticClass: "operator"
      }, [_vm._v(_vm._s(mainOperator))]), _c('div', {
        staticClass: "connector"
      })]) : _vm._e()], 2);
    }), 0);
  }), _c('div', {
    staticClass: "expression-connector"
  }, [_vm.form.conditions[Object.keys(_vm.form.conditions)[0]].length ? _c('div', {
    staticClass: "connector"
  }) : _vm._e(), !_vm.deleteMode ? _c('div', {
    staticClass: "add-block-ctn"
  }, [!_vm.form.conditions[Object.keys(_vm.form.conditions)[0]].length ? _c('div', {
    staticClass: "title"
  }, [_vm._v("Get started by adding a condition:")]) : _vm._e(), _c('v-btn', {
    staticClass: "my-2",
    attrs: {
      "large": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.addConditionBlock(Object.keys(_vm.form.conditions)[0]);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-plus-circle-outline")]), _vm._v(" Add Expression Block ")], 1), _c('br'), _vm.form.conditions[Object.keys(_vm.form.conditions)[0]].length ? _c('div', {
    staticClass: "d-flex align-content justify-center"
  }, [_c('span', {}, [_vm._v(" Connection expression blocks by: ")]), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "d-flex ml-2 align-center justify-center conditional-operator"
        }, 'button', attrs, false), on), [_vm._v(" " + _vm._s(Object.keys(_vm.form.conditions)[0]) + " "), _c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v(" mdi-menu-down ")])], 1)];
      }
    }], null, false, 2706536540)
  }, [_c('v-list', _vm._l(_vm.conditionalOperators, function (item) {
    return _c('v-list-item', {
      key: item.key,
      on: {
        "click": function ($event) {
          _vm.selectOperator(item.key, Object.keys(_vm.form.conditions)[0]);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.value) + " ")])], 1);
  }), 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.form.conditions[Object.keys(_vm.form.conditions)[0]].length ? _c('div', {
    staticClass: "connector"
  }) : _vm._e(), _vm.form.conditions[Object.keys(_vm.form.conditions)[0]].length ? _c('div', {
    staticClass: "operator"
  }, [_vm._v("end.")]) : _vm._e()])], 2)])], 1), _c('v-divider')], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")]), !_vm.deleteMode ? _c('v-btn', {
    attrs: {
      "loading": _vm.saving,
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm.deleteMode ? _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.deleteMode = !_vm.deleteMode;
      }
    }
  }, [_vm._v("Done Deleting")]) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }